const OFFSCREEN = -100000;
export const OFFSCREEN_RECT = new DOMRect(OFFSCREEN, OFFSCREEN, 0, 0);
